export default function church() {
  return [
    'audioSeries',
    'videoSeries',
    'serviceCountdown',
  ];
}



// WEBPACK FOOTER //
// ./src/global-view/editor/page/droplets-tab/site-types/church.js